import image from "./userGroups.svg";
import { FormattedMessage, useIntl } from "react-intl";
import {
  BottomButton,
  BottomButtonContainer,
} from "../../../elements/wrapper/bottomButton.wrapper.jsx";
import StandardRadioButton from "../../../elements/buttons/standardRadioButton.jsx";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import { useState } from "react";
import IntroImage from "../../introImage.component.jsx";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import StandardInstruction from "../../../elements/text/standardInstruction.component.jsx";
import { pageNames } from "../../../../reduxStore/reducers/main.js";

export default function UserGroups(props) {
  const intl = useIntl();
  const [selectedGroup, setSelectedGroup] = useState("none");
  const userGroups = [
    {
      name: intl.formatMessage({ id: "welcome.userGroup.patient" }),
      key: "patient",
    },
    {
      name: intl.formatMessage({ id: "welcome.userGroup.visitor" }),
      key: "visitor",
    },
    {
      name: intl.formatMessage({ id: "welcome.userGroup.employee" }),
      key: "employee",
    },
    {
      name: intl.formatMessage({ id: "welcome.userGroup.supplier" }),
      key: "supplier",
    },
    {
      name: intl.formatMessage({ id: "welcome.userGroup.student" }),
      key: "student",
    },
    {
      name: intl.formatMessage({ id: "welcome.userGroup.none" }),
      key: "none",
    },
  ];

  const handleClick = () => {
    if (props.userGroup === "employee") {
      props.setProperty("employee", true);
    }
    props.setProperty("userGroup", selectedGroup);

    props.history.push(
      `${
        !props.skipCampusSelection
          ? `/${pageNames.intro}/${pageNames.selectCampus}/${getQueryParams()}`
          : `/${pageNames.intro}/${
              pageNames.selectLocation
            }/${getQueryParams()}`
      }`
    );
  };
  const handleBack = () => {
    props.history.goBack();
  };

  return (
    <BottomButtonContainer
      buttons={[
        new BottomButton(
          handleBack,
          <FormattedMessage id={"search.buttonBack"} />,
          { className: "mr-3 normalButton--naked" }
        ),
        new BottomButton(handleClick, <FormattedMessage id="welcome.next" />, {
          className: "normalButton--primary",
        }),
      ]}
    >
      <IntroImage imageName={"userGroups.svg"} fallbackImage={image} />
      <div className=" general-padding-large-horizontally">
        <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
          <FormattedMessage id="welcome.userGroupSelectionTitle" />
        </StandardHeadline>
        <StandardInstruction className={"mb-4"} type={"p"}>
          <FormattedMessage id="welcome.userGroupSelectionText" />
        </StandardInstruction>

        <div className="d-flex flex-column">
          {userGroups.map((u) => (
            <div
              className="general-margin-bottom pl-3 pr-3 d-flex justify-content-between"
              key={u.key}
              onClick={() => setSelectedGroup(u.key)}
            >
              <div>
                <span className="d-inline-block">{u.name}</span>
              </div>
              <StandardRadioButton selected={u.key === selectedGroup} />
            </div>
          ))}
        </div>
      </div>
    </BottomButtonContainer>
  );
}
